import React, { useState, useRef } from "react";
import "../styles/background.css";
import video from "../assets/bg-universe-2.mp4";
import fallbackImage from "../assets/hallow.png";

const Background = () => {
  const [videoLoaded, setVideoLoaded] = useState(false);
  const videoRef = useRef(null);

  const handleVideoLoaded = () => {
    setVideoLoaded(true); // Hide the image and show the video when it's ready
  };

  return (
    <>
      <div className="shadow-overlay"></div>

      {/* Fallback image will be shown until the video is ready */}
      {!videoLoaded && (
        <img
          src={fallbackImage}
          alt="Fallback"
          className="fallback-image"
          style={{ position: "absolute", width: "100%", height: "100%" }}
        />
      )}

      {/* Video will be hidden until it's loaded */}
      <video
        ref={videoRef}
        playsInline
        autoPlay
        muted
        loop
        preload="auto"
        id="bg"
        style={videoLoaded ? { display: "block" } : { display: "none" }}
        onLoadedData={handleVideoLoaded}
      >
        <source src={video} type="video/mp4" />
      </video>
    </>
  );
};

export default Background;
